export class CreateInternalUserRequest {
  constructor(
    public email: string,
    public type: string,
  ) {}
}
